import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import Products from 'merchandise-lib/constants/Product';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const fetchLimitUsage = () => http.get('/feature/store/v1/usage', {
  query: {
    upgradeApiName: Products.CRM_SUITE_STARTER_BUNDLE
  }
});
export const GET_LIMIT_USAGE = registerQuery({
  fieldName: 'limitUsages',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, fetchLimitUsage);
  }
});